//是否全屏 flag true、false
const requestFullScreen = (flag) => window.androidinfo.requestFullScreen(flag)
// 设置状态栏颜色
const changeStatusBarTextColor = (isLight) => window.androidinfo.changeStatusBarTextColor(isLight)
// 打开原生应用
const openApplication = (key) => window.androidinfo.openApplication(key)
// 获取版本号
const getAppVersionCode = () => window.androidinfo.getAppVersionCode()
// 获取版本号
const getAppVersionName = () => window.androidinfo.getAppVersionName()
// 是否联网
const isNetworkAvailable = () => window.androidinfo.isNetworkAvailable()
// 下载新版本
const downloadNewApk = (url) => window.androidinfo.downloadNewApk(url)
// 第三方授权
const thirdLogin = (platform) => window.androidinfo.thirdLogin(platform)
// 第三方登录
const thirdShare = (platformName, title, imageUrl, url, shareType) => window.androidinfo.thirdShare(platformName, title, imageUrl, url, shareType)
// 复制到剪切板
const copyToClipboard = (text) => window.androidinfo.copyToClipboard(text)
//横屏竖屏
const changeScreenOrientation = () => window.androidinfo.changeScreenOrientation()
// 文件下载
const downloadFile = (fileUrl, fileName) => window.androidinfo.downloadFile(fileUrl, fileName)
// 文件下载
const downloadFile2 = (fileUrl, fileName, dirName) => window.androidinfo.downloadFile(fileUrl, fileName, dirName)
// 下载的文件
const getDownloadFiles = () => window.androidinfo.getDownloadFiles()
// 下载的文件删除
const deleteDownloadFile = (fileName) => window.androidinfo.deleteDownloadFile(fileName)
// 打开下载的文件
const openDownloadFile = (filePath) => window.androidinfo.openDownloadFile(filePath)
// 获取下载的文件大小
const getDownloadSize = () => window.androidinfo.getDownloadSize()
// 获取剩余空间大小
const getAvailableSize = () => window.androidinfo.getAvailableSize()
// 顶部高度
const getStatusBarHeight = () => window.androidinfo.getStatusBarHeight()
// 获取历史词汇
const getSearchWord = () => window.androidinfo.getSearchWord()
// 保存搜索词汇
const saveSearchWord = (text) => window.androidinfo.saveSearchWord(text)
// 清空历史词汇
const clearAllSearchWord = () => window.androidinfo.clearAllSearchWord()
// 二维码扫描
const startScan = (flag) => window.androidinfo.startScan(flag)
// 获取缓存大小
const getCacheSize = () => window.androidinfo.getCacheSize()
// 清除缓存
const clearCache = () => window.androidinfo.clearCache()
//上传图片最大上传数量
const setFileMaxCount = (num) => window.androidinfo.setFileMaxCount(num)
//上传视频最大上传数量
const setMaxVideoCount = (num) => window.androidinfo.setMaxVideoCount(num)
//自定义选择文件、视频、图片时，单个大小限制
// size是字符串，如:'20971520'是20M(20 * 1024 * 1024)，不设置默认文件是100M，图片是20M，视频是1G，设'no_limit'是不限制
const setSingleFileMaxSize = (size) => window.androidinfo.setSingleFileMaxSize(size)
// 图片是否裁剪
const setIsImageCrop = (isCrop) => window.androidinfo.setIsImageCrop(isCrop)
//setToken
const setToken = (token) => window.androidinfo.setToken(token)
// 内部入口使用
const setOfficeToken = (token) => window.androidinfo.setOfficeToken(token)
//setUserId
const setUserId = (userId) => window.androidinfo.setUserId(userId)
//setUserName
const setUserName = (username) => window.androidinfo.setUserName(username)
//setPhone
const setPhone = (phone) => window.androidinfo.setPhone(phone)
//log
const log = (str) => window.androidinfo.log(str)
//清除累加路由
const clearAllHistory  = () => window.androidinfo.clearAllHistory();
// 跳转到抖音主页
const openDouYinUser = () => window.androidinfo.openDouYinUser();
//启动本地浏览器，打开链接
const openBrowser = (url) => window.androidinfo.openBrowser(url);
// 导出
const exportExcel = (url, params, dirName, fileName) => window.androidinfo.exportRecords(url, params, dirName, fileName)
// 使用wps打开文件url，如果未安装wps则使用浏览器
const openDocumentWithWPS = (documentUrl) => window.androidinfo.openDocumentWithWPS(documentUrl)
// 存储有权限的应用
const saveApplicationHasPermission = (applyKey) => window.androidinfo.saveApplicationHasPermission(applyKey)
// 获取存储的有权限的应用
const getApplicationHasPermission = () => window.androidinfo.getApplicationHasPermission()
// 清空已存储有权限的应用
const clearSavedApplications = () => window.androidinfo.clearSavedApplications()
// 打开绩效表文件
const openKBIFile = (documentUrl, documentName) => window.androidinfo.openKBIFile(documentUrl, documentName)
// 关闭安卓绩效表服务
const stopKBIService = () => window.androidinfo.stopKBIService()
// pdf、txt、等文件多选，maxChoose：最多选中个数, enableExt：可以选择的文件后缀.pdf, chooseFiles：已经选择的文件
const openDocumentChoose = (maxChoose, enableExt, chooseFiles) => window.androidinfo.openDocumentChoose(maxChoose, enableExt, chooseFiles)
// 自定义选择文件需要调用，区分文档、视频、图片
const setFileChooseType = (chooseType) => window.androidinfo.setFileChooseType(chooseType)
// 如果下载文件需要进度调用 dir: 目录，提示使用
const beforeDownloadFiles = (ary, dir) => window.androidinfo.beforeDownloadFiles(ary, dir)
// 通过接口下载文件 fileId：单个文件下载且需要显示进度时必传
const downloadFileByRequest = (url, params, dirName, fileName, fileId) => window.androidinfo.downloadFileByRequest(url, params, dirName, fileName, fileId)
// 视频预览
const openVideoPreviewActivity = (videoUrl, videoName) => window.androidinfo.openVideoPreviewActivity(videoUrl, videoName)

export default {
  requestFullScreen,
  changeStatusBarTextColor,
  openApplication,
  getAppVersionCode,
  getAppVersionName,
  isNetworkAvailable,
  downloadNewApk,
  thirdLogin,
  thirdShare,
  copyToClipboard,
  changeScreenOrientation,
  downloadFile,
  downloadFile2,
  getDownloadFiles,
  deleteDownloadFile,
  openDownloadFile,
  getDownloadSize,
  getAvailableSize,
  getStatusBarHeight,
  getSearchWord,
  saveSearchWord,
  clearAllSearchWord,
  startScan,
  getCacheSize,
  clearCache,
  setFileMaxCount,
  setMaxVideoCount,
  setSingleFileMaxSize,
  setIsImageCrop,
  setToken,
  setOfficeToken,
  setUserId,
  setUserName,
  setPhone,
  log,
  clearAllHistory,
  openDouYinUser,
  openBrowser,
  exportExcel,
  openDocumentWithWPS,
  saveApplicationHasPermission,
  getApplicationHasPermission,
  clearSavedApplications,
  openKBIFile,
  stopKBIService,
  openDocumentChoose,
  setFileChooseType,
  beforeDownloadFiles,
  downloadFileByRequest,
  openVideoPreviewActivity
}


// WEBPACK FOOTER //
// ./src/utils/androidinfo.js